import React, { useState, useEffect } from 'react';

const ArticleForm = () => {
  const [article, setArticle] = useState({
    name: '',
    price: '',
    description: '',
    stock: '',
    categorie: '',
    code_barres: '',
    fournisseur: '',
    seuil_reapprovisionnement: '',
    prix_achat: '',
    unite_mesure: ''
  });

  const [articles, setArticles] = useState([]);

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/articles`);
        if (!response.ok) {
          throw new Error('Erreur lors de la récupération des articles');
        }
        const data = await response.json();
        setArticles(data);
      } catch (error) {
        console.error('Erreur:', error);
      }
    };

    fetchArticles();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setArticle(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!article.name || !article.price) {
      alert('Le nom et le prix sont obligatoires.');
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/articles`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(article),
      });

      if (!response.ok) {
        throw new Error('Erreur lors de l\'ajout de l\'article');
      }

      const data = await response.json();
      console.log('Article ajouté:', data);

      setArticles(prevArticles => [...prevArticles, data]);

      setArticle({
        name: '',
        price: '',
        description: '',
        stock: '',
        categorie: '',
        code_barres: '',
        fournisseur: '',
        seuil_reapprovisionnement: '',
        prix_achat: '',
        unite_mesure: ''
      });

      alert('Article ajouté avec succès!');
    } catch (error) {
      console.error('Erreur:', error);
      alert('Erreur lors de l\'ajout de l\'article');
    }
  };

  return (
    <div className="container">
      <form onSubmit={handleSubmit}>
        <div>
          <input
            type="text"
            name="name"
            value={article.name}
            onChange={handleChange}
            placeholder="Nom de l'article"
            required
          />
        </div>
        <div>
          <input
            type="number"
            name="price"
            value={article.price}
            onChange={handleChange}
            placeholder="Prix"
            required
          />
        </div>
        <div>
          <textarea
            name="description"
            value={article.description}
            onChange={handleChange}
            placeholder="Description"
          />
        </div>
        <div>
          <input
            type="number"
            name="stock"
            value={article.stock}
            onChange={handleChange}
            placeholder="Stock"
          />
        </div>
        <div>
          <input
            type="text"
            name="categorie"
            value={article.categorie}
            onChange={handleChange}
            placeholder="Catégorie"
          />
        </div>
        <div>
          <input
            type="text"
            name="code_barres"
            value={article.code_barres}
            onChange={handleChange}
            placeholder="Code-barres"
          />
        </div>
        <div>
          <input
            type="text"
            name="fournisseur"
            value={article.fournisseur}
            onChange={handleChange}
            placeholder="Fournisseur"
          />
        </div>
        <div>
          <input
            type="number"
            name="seuil_reapprovisionnement"
            value={article.seuil_reapprovisionnement}
            onChange={handleChange}
            placeholder="Seuil de réapprovisionnement"
          />
        </div>
        <div>
          <input
            type="number"
            name="prix_achat"
            value={article.prix_achat}
            onChange={handleChange}
            placeholder="Prix d'achat"
          />
        </div>
        <div>
          <input
            type="text"
            name="unite_mesure"
            value={article.unite_mesure}
            onChange={handleChange}
            placeholder="Unité de mesure"
          />
        </div>
        <button type="submit">Ajouter l'article</button>
      </form>

      <div>
        <h2>Liste des articles</h2>
        <ul>
          {articles.map((art, index) => (
            <li key={index}>
              {art.name} - {art.price} € <br /> {art.description}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ArticleForm;
